import React from 'react';
import { uniq } from 'lodash';
import { AuthenticatedPortalDataType } from '../components/Onboarding/Login/onboardingLoginTypes';
import UsersClient from '../clients/UsersClient';
import { RouteContext, SessionData } from '../context';

type getWorkspacesOptions = {
  querySession?: boolean;
};

export const useWorkspaces = () => {
  const [loadingWorkspaces, setLoadingWorkspaces] = React.useState(false);
  const { sessionData } = React.useContext(RouteContext);

  const getWorkspaces = async ({ querySession }: getWorkspacesOptions = {}) => {
    setLoadingWorkspaces(true);
    let portalIdToSession: SessionData['portalIdToSession'] = {};
    // get valid portal sessions
    if (querySession) {
      // if useApi is true, call the API to get the sessions
      const portalSessionsResponse = await UsersClient.getSessions();
      portalIdToSession = portalSessionsResponse.data.portalIdToSession;
    } else {
      // otherwise, use the session data from the context
      portalIdToSession = sessionData.portalIdToSession;
    }

    // extract the unique list of emails from the portal sessions
    const userEmails = uniq(
      Object.values(portalIdToSession || {})
        .map(session => session.email || '') // use || to satisfy typescript
        .filter(Boolean),
    );

    try {
      // call GET /workspaces to get the workspaces
      const workspaces: Record<
        string,
        Record<string, AuthenticatedPortalDataType>
      > = await UsersClient.getWorkspaces(userEmails);
      setLoadingWorkspaces(false);

      return { workspaces, portalIdToSession };
    } catch (ex) {
      console.error('Error getting workspaces', ex);
      setLoadingWorkspaces(false);
    }
    return {
      workspaces: {},
      portalIdToSession: {},
    };
  };

  return { getWorkspaces, loadingWorkspaces };
};
